import http from '@/utils/http'

/**
 *  配置列表
*/
export function getConfigList(params) {
    return http({
            url: '/system/sysAccessConfig/paging',
            method: 'get',
            params
    })
}

/**
 *  配置详情
*/
export function getConfigDetail(params) {
    return http({
            url: '/system/sysAccessConfig/find',
            method: 'get',
            params
    })
}

/**
 *  添加配置
*/
export function addConfig(data) {
    return http({
        url: '/system/sysAccessConfig/add',
        method: 'post',
        data
    })
}

/**
 *  修改配置
*/
export function updateConfig(data) {
    return http({
        url: '/system/sysAccessConfig/update',
        method: 'post',
        data
    })
}

/**
 *  删除配置
*/
export function delConfig(data) {
    return http({
        url: '/system/sysAccessConfig/delete',
        method: 'post',
        params: data
    })
}

/**
 *  启用/禁用
*/
export function avalChange(data) {
    return http({
        url: '/system/sysAccessConfig/available',
        method: 'post',
        data
    })
}
